
/* injects from baggage-loader */

'use strict';

import officeSearchDirective from './officeSearch.directive';
import officeSearchConstant from './officeSearch.constant';

/**
 * Officesearch module definition.
 */
const officeSearchModule = angular.module('officeSearch.module', []);

officeSearchModule.directive('officeSearch', officeSearchDirective);
officeSearchModule.constant('officeSearchConstant', officeSearchConstant);

export default officeSearchModule;



// WEBPACK FOOTER //
// ./src/app/core/components/officeSearch/officeSearch.module.js